export const FLATS = ['квартира', 'квартиры', 'квартир']
export const ROOMS = ['комната', 'комнаты', 'комнат']
export const DAYS = ['день', 'дня', 'дней']
export const HOUSES = ['дом', 'дома', 'домов']
export const ELEMENTS = ['элемент', 'элемента', 'элементов']
export const YEARS = ['год', 'года', 'лет']
export const REMARKS = ['замечание', 'замечания', 'замечаний']
export const HOURS = ['час', 'часа', 'часов']
export const MINUTES = ['минута', 'минуты', 'минут']

/**
 *
 * @param n {number}
 * @param words {string[]}
 * @returns {string}
 */
export const declinationWord = (n, words) => {
  return words[(n % 100 > 4 && n % 100 < 20)
    ? 2 : [2, 0, 1, 1, 1, 2][(n % 10 < 5) ? n % 10 : 5]]
}
